import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShowAll } from "../../../../../..";

function PendingAcceptance(props) {
  const { requestData } = props;
  const { request_bid, request } = requestData;

  return (
    <>
      {request_bid.length > 0 && (
        <div className="bid-status-wrapper pt-4 border-bottom mb-4">
          <div className="row">
            <div className="col-12 text-center">
              <p className="font-weight-bold mb-1">
                {request_bid.length}{" "}
                {request_bid.length === 1 ? "company" : "companies"} have bet on
                your order.
              </p>
              <p className="mb-0">
                <Link
                  to={"/dashboard/my-requests/companies-list/" + request.id}
                  className="red-color text-uppercase font-weight-bold small-sub-title"
                >
                  Show All
                </Link>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PendingAcceptance;
